export default "__VITE_ASSET__e9825963__"